/* eslint-disable  */
import React, { useEffect, useState, useRef } from 'react';
import {
  DataGrid,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
} from '@mui/x-data-grid';
import ButtonGroup from '@material-ui/core/ButtonGroup';

import dayjs from 'dayjs';
import { Tooltip } from '@mui/material';

import useBoletimContext from 'context/BoletimContext';
import { Button, makeStyles } from '@material-ui/core';
import ScheduleIcon from '@material-ui/icons/Schedule';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import theme from 'styles/theme';
import { green, orange, red } from '@material-ui/core/colors';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { TextFieldProps } from '@mui/material';
import { IGridDaily } from '../NewDailyBulletinPlanningGrid/types';
import SnackBarMessages from 'components/atoms/Snackbar';

const NewDailyBulletinPlanningGridDetails = ({
  data,
  params,
  toggleState,
  isLoading,
}: IGridDaily) => {
  const resultDataPush = data;

  useEffect(() => {
    //const resultData = data;
    let equipName = '';
    for (let k = 0; k < params[0].activity.length; k += 1) {

      // só incluir quando existir atividade e Fornecedor, pois são campos obrigatorios
      if (
        params[0].activity[k].label !== undefined &&
        params[0].providerName !== undefined
      ) {
        //Equipamento não é obrigatprio, mas se existir, será uma lista, por isso o for abaixo
        if (params[0].equipment !== undefined && params[0].equipment.length > 0) {
          for (let eq = 0; eq < params[0].equipment.length; eq += 1)
            resultDataPush.push({
              ...params[0],
              activityDiverseId: params[0].id,
              activitiesId: params[0].activity[k].id,
              activityDescription: params[0].activity[k].label,
              bulletinStatus: params[0].bulletinFlag,
              clusterId: params[0].clusterId[0],
              equipmentDescription: params[0].equipment[eq].description,
              equipmentId: params[0].equipment[eq].id,
              providerDescription: params[0].providerName,
              completionPrev: params[0].completion,
              startPrevBr: params[0].start,
              tipo: toggleState,
            });
        } else {
          resultDataPush.push({
            ...params[0],
            activityDiverseId: params[0].id,
            activitiesId: params[0].activity[k].id,
            activityDescription: params[0].activity[k].label,
            bulletinStatus: params[0].bulletinFlag,
            clusterId: params[0].clusterId[0],
            equipmentDescription: null,
            equipmentId: null,
            providerDescription: params[0].providerName,
            completionPrev: params[0].completion,
            startPrevBr: params[0].start,
            tipo: toggleState,
          });
        }
      }
    }
  }, [params, resultDataPush, toggleState]);
  // verificar se precisa do status //

  const useStyles = makeStyles({
    container: {
      '& .makeStyles-container-334': {
        maxHeight: 0,
      },
      marginBottom: '15px',

      '& MuiDataGrid-root': {
        border: 'none',
      },
      '& .MuiDataGrid-virtualScrollerRenderZone': {
        height: '600px',
        overflowY: 'auto !important',
        minHeight: '87px',
      },
      '& .MuiDataGrid-virtualScroller': {
        width: '644px',
        height: '585px !important',
      },
      display: 'flex',
      flexWrap: 'wrap',

      '& .laranja': {
        backgroundColor: orange[50] + ' !important',
      },
    },

    root: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    gridHeader: {
      display: 'flex',
      margin: '15px 40px 0 0',
    },
    h2: {
      color: 'rgb(88, 147, 241)',
      display: 'inline-block',
      fontSize: '1.2rem',
      marginBottom: '8px',
      marginRight: '12px',
      marginTop: '13px',
      minWidth: '180px',
    },
    button: { width: '20px' },
    buttonGroup: {
      margin: '8px 4px',
      '& .MuiButton-label': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
      },
    },
    singleButton: {
      margin: '8px 4px',
      padding: '5px',
    },

    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
      border: '1px solid #000000c8',
      borderRadius: 6,
      fontSize: '12px',

      '& .MuiInputLabel-animated': {
        margin: '4px',
      },
      '& label + .MuiInput-formControl': {
        marginLeft: '4px',
        marginRight: '9px',
      },
      '& .MuiInput-underline:before': {
        display: 'none',
      },
      '& .MuiInputBase-input': {
        padding: '7px 7px',
      },
    },
  });
  const classes = useStyles();
  const [openDialogEditar, setOpenDialogEditar] = useState<boolean>(false);
  const [openDialogExcluir, setOpenDialogExcluir] = useState<boolean>(false);

  const { boletinsWTG, setBoletinsWTG } = useBoletimContext();

  const [rows, setRows] = useState<any[]>([]);
  const [linhasSelecionadas, setLinhasSelecionadas] = useState<any[]>([]);

  const inputDataInicial = useRef<TextFieldProps>(null);
  const inputDataFinal = useRef<TextFieldProps>(null);

  const [openMessageError, setOpenMessageError] = React.useState(false);

  const onReset = () => {
    setLinhasSelecionadas([]);
  };

  const onSetGridBoletim = () => {
    const temp = rows?.filter(row => linhasSelecionadas.includes(row.id));
    const arrTemp = [...boletinsWTG, ...temp];
    console.log("objeto antes de ir pro grid", arrTemp);
    
    setBoletinsWTG(
      arrTemp.filter((v, i, a) => a.findIndex(t => t.id === v.id) === i),
    );
    onReset();
  };

  const onChangeDateNow = () => {
    const updateRows: any[] = rows.map(row => {
      if (linhasSelecionadas.includes(row?.id)) {
        row.startPrevBr = formatDate(new Date(), true);
        row.completionPrev = formatDate(new Date(), false);
        row.activityPlanId = null;
      }
      return rows;
    });
    onReset();
    setOpenDialogExcluir(false);
  };

  const onChangeDate = (datai, dataf) => {
    if (dayjs(datai).isAfter(dayjs(dataf))) {
      setOpenMessageError(true);
      return;
    }
    const updateRows: any[] = rows.map(row => {
      if (linhasSelecionadas.includes(row?.id)) {
        row.startPrevBr = dayjs(datai).format('DD/MM/YYYY HH:mm');
        row.completionPrev = dayjs(dataf).format('DD/MM/YYYY HH:mm');
      }
      return rows;
    });
    onReset();
    setOpenDialogEditar(false);
  };

  const onDeselecionarLinhas = () => {
    linhasSelecionadas.map(item => item.id);
  };

  useEffect(() => {
    // Criar um array com todos os IDs inteiros de 0 a 218999
    const idList = Array.from(Array(219000).keys());

    // Remover IDs que já foram usados
    resultDataPush.forEach(item => {
      const idIndex = idList.indexOf(item.id);
      if (idIndex !== -1) {
        idList.splice(idIndex, 1);
      }
    });

    // ajustando o Array de atividades para o formato do Grid
    const tempRows = resultDataPush.map((item, j) => {
      let rowAdd = false;
      const id =
        item.id == 0 || item.id == undefined
          ? idList.splice(Math.floor(Math.random() * idList.length), 1)[0]
          : item.id;

      rowAdd = item.id == 0 || item.id == undefined ? true : false;
      
      return {
        activityDiverseId: params[0].activityDiverseId,
        activitiesId: item.activitiesId,
        activity: item.activityDescription,
        activityDescription: item.activityDescription,
        activityName: item.activityName,
        activityPlanId: item.activityPlanId,
        area: item.area,
        areaORequipmentDescription: item.equipmentDescription || item.area,
        clusterId: item.clusterId,
        completion: item?.completion,
        completionPercentage: 0,
        completionPrev: dayjs(
          item.realCompletion ? item.realCompletion : item.completion,
        )
          .format('DD/MM/YYYY HH:mm')
          .toString(),
        durationPrev: dayjs(item.completionPrev, 'hour').diff(
          item.startReplanBr ? item.startReplanBr : item.startPrevBr,
          'hour',
        ),
        equipmentDescription: item.equipmentDescription,
        equipmentId: item.equipmentId,
        equipmentTag: item.equipmentDescription,
        id,
        instalationId: item.instalationId,
        installationId: item.installationId,
        maintenance:
          item.maintenanceType === undefined
            ? item.maintenance
            : item.maintenanceType,
        outage: item.outage,
        planNumber: item.planNumber,
        providerDescription: item.providerDescription,
        realCompletion: item?.realCompletion,
        realStart: item?.realStart,
        rowadd: rowAdd,
        start: item?.start,
        startPrevBr: dayjs(item.realStart ? item.realStart : item.start)
          .format('DD/MM/YYYY HH:mm')
          .toString(),
        tipo: toggleState,
        utilization: item.utilization,
      };
    });

    setRows(tempRows);
  }, [resultDataPush]);

  useEffect(() => {
    resultDataPush.pop();
    // rows.pop();
  }, [toggleState]);

  const columns: GridColDef[] = [
    {
      field: 'areaORequipmentDescription',
      headerName: 'Outros',
      resizable: true,
      flex: 2,
      width: 160,
      renderCell: (params: any) => (
        <Tooltip
          title={`${params?.row?.areaORequipmentDescription} ' | '  ${params?.row?.areaORequipmentDescription}`}
        >
          <span>{params?.row?.areaORequipmentDescription}</span>
        </Tooltip>
      ),
    },
    {
      field: 'activityDescription',
      headerName: 'Atividade',
      resizable: true,
      flex: 2,
      width: 160,
      renderCell: (params: any) => (
        <Tooltip title={params?.row?.activityDescription}>
          <span>{params?.row?.activityDescription}</span>
        </Tooltip>
      ),
    },
    {
      field: 'startPrevBr',
      headerName: 'Início',
      width: 130,
      editable: false,
      renderCell: (params: any) => (
        <Tooltip title={params?.row?.startPrevBr}>
          <span>{params?.row?.startPrevBr}</span>
        </Tooltip>
      ),
    },
    {
      field: 'completionPrev',
      headerName: 'Final',
      width: 130,
      editable: false,
      renderCell: (params: any) => (
        <Tooltip title={params?.row?.completionPrev}>
          <span>{params?.row?.completionPrev}</span>
        </Tooltip>
      ),
    },
  ];

  function padTo2Digits(num: number) {
    return num.toString().padStart(2, '0');
  }
  // eslint-disable-next-line prefer-template
  function formatDate(date: Date, isInicio: boolean) {
    let hora = '';
    const barra = '/';
    if (isInicio) {
      hora = '  08:00:00';
    } else {
      hora = '  17:00:00';
    }
    return (
      [
        padTo2Digits(date.getDate()),
        padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join(barra) + hora
    );
  }

  return (
    <>
      <SnackBarMessages
        type={'error'}
        message={'Término previsto não pode ser menor que o início previsto.'}
        open={openMessageError}
        handleClose={() => { setOpenMessageError(false); }}
        duration={5000}
      />
      <div className={classes.gridHeader}>
        <h2 className={classes.h2}>Planejamento diário</h2>

        <Button
          variant="outlined"
          color="primary"
          className={`${classes.button} ${classes.singleButton}`}
          aria-label="outlined primary button"
          title="Adicionar ao Boletim"
          onClick={onSetGridBoletim}
        >
          Adicionar
        </Button>
        <ButtonGroup
          color="primary"
          aria-label="outlined primary button group"
          className={classes.buttonGroup}
        >
          <Button
            className={classes.button}
            title="Início"
            onClick={() => {
              setOpenDialogEditar(true);
            }}
            style={{ width: '120px', color: green[500] }}
          >
            <ScheduleIcon style={{ fontSize: '17px' }} />
            Editar
          </Button>
        </ButtonGroup>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => {
            setOpenDialogExcluir(true);
          }}
          className={`${classes.button} ${classes.singleButton}`}
          aria-label="outlined primary button"
          title="Remover atividade"
        >
          <DeleteOutlineOutlinedIcon />
        </Button>
      </div>

      <DataGrid
        className={classes.container}
        rows={rows}
        columns={columns}
        headerHeight={30}
        rowHeight={30}
        checkboxSelection
        getRowClassName={params => {
          return params.row.rowadd ? 'laranja' : '';
        }}
        isRowSelectable={params => { return params.row.rowadd}}
        autoHeight
        // hideFooter
        hideFooterSelectedRowCount
        experimentalFeatures={{ newEditingApi: true }}
        onSelectionModelChange={setLinhasSelecionadas}
        selectionModel={linhasSelecionadas}
        getRowId={row => row.id}
        disableSelectionOnClick
      />
      {/* {isLoading && <Loading />} */}
      <Dialog
        open={openDialogEditar}
        onClose={() => {
          setOpenDialogEditar(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          id="form-dialog-title"
          style={{
            fontSize: 16,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          Selecione a data para ser alterada
        </DialogTitle>
        <DialogContent>
          <TextField
            id="txtDataInicial"
            label="Início"
            type="datetime-local"
            inputRef={inputDataInicial}
            defaultValue={dayjs().format('YYYY-MM-DDTHH:mm')}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            id="txtDataFinal"
            label="Final"
            inputRef={inputDataFinal}
            type="datetime-local"
            defaultValue={dayjs().format('YYYY-MM-DDTHH:mm')}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: `${inputDataInicial.current?.value}`, 
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialogEditar(false);
            }}
            color="secondary"
          >
            Cancelar
          </Button>
          <Button
            onClick={() => {
              setOpenDialogEditar(false);
              const linhasEscolhidas = linhasSelecionadas;
              const datai: any = inputDataInicial.current?.value;
              const dataf: any = inputDataFinal.current?.value;

              onChangeDate(datai, dataf);
              linhasEscolhidas.forEach(function (item) {
                setRows(
                  rows.map(function (grid) {
                    if (grid.id === item.id) {
                      const linhaEditada = item;

                      return linhaEditada;
                    }
                    return grid;
                  }),
                );
              });
              onDeselecionarLinhas();
            }}
            color="primary"
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDialogExcluir}
        onClose={() => {
          setOpenDialogExcluir(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" style={{ textAlign: 'center' }}>
          Confirma a exclusão das linhas selecionada(s)
        </DialogTitle>
        <DialogContent
          style={{
            fontSize: 16,
            color: '#000000b7',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          As atividades selecionadas serão excluídas (mantida em aberto/atraso)
          e novas atividades criadas, deseja prosseguir?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenDialogExcluir(false);
            }}
            color="secondary"
          >
            Cancelar
          </Button>
          <Button onClick={onChangeDateNow} color="primary">
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NewDailyBulletinPlanningGridDetails;